import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import 'bootstrap/dist/css/bootstrap.css'
import App from './App';

const shouldForwardProp = (propName, target) => {
  if (typeof target === 'string') {
    return isPropValid(propName);
  }
  return true;
};

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <StyleSheetManager shouldForwardProp={shouldForwardProp}>
    <HashRouter>
      <App />
    </HashRouter>
  </StyleSheetManager>
);